import React from 'react';
import Rotate from 'react-reveal/Rotate';
import useTitle from '../../hook/useTitle';
const Blog = () => {
  useTitle('Portfolio || Blog');
  return (
    <section className="w-screen h-screen flex items-center justify-center">
      <Rotate bottom left>
        <h3 className="text-[#64feda] text-2xl my-24">Coming soon</h3>
      </Rotate>
    </section>
  );
};

export default Blog;
